var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';

var InfoContent = function (_React$PureComponent) {
  _inherits(InfoContent, _React$PureComponent);

  function InfoContent() {
    _classCallCheck(this, InfoContent);

    return _possibleConstructorReturn(this, (InfoContent.__proto__ || Object.getPrototypeOf(InfoContent)).apply(this, arguments));
  }

  _createClass(InfoContent, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        React.Fragment,
        null,
        React.createElement(
          'div',
          { style: { fontWeight: 'bold', color: '#EA80FC' } },
          this.props.id
        ),
        this.props.description && React.createElement(
          'p',
          { style: { margin: '6px 0 0 0' } },
          this.props.description
        )
      );
    }
  }]);

  return InfoContent;
}(React.PureComponent);

InfoContent.propTypes = {
  id: PropTypes.string.isRequired,
  description: PropTypes.string
};
export default InfoContent;


//////////////////
// WEBPACK FOOTER
// ../lib/components/InfoContent.js
// module id = 114
// module chunks = 0